var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "23px",
    viewBox: "0 0 28 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FilterIcon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FilterIcon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5,0 C8.19578751,4.95208133e-16 10.4385861,1.93947601 10.9091642,4.49919636 L24,4.5 C24.5522847,4.5 25,4.94771525 25,5.5 C25,6.05228475 24.5522847,6.5 24,6.5 L10.9093471,6.49980813 C10.4391676,9.06002112 8.19613698,11 5.5,11 C2.46243388,11 -1.77635684e-15,8.53756612 -1.77635684e-15,5.5 C0,2.46243388 2.46243388,-5.57991845e-16 5.5,0 Z M5.5,2 C3.56700338,2 2,3.56700338 2,5.5 C2,7.43299662 3.56700338,9 5.5,9 C7.43299662,9 9,7.43299662 9,5.5 C9,3.56700338 7.43299662,2 5.5,2 Z",
    id: "Combined-Shape",
    fill: "#979598"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,12 C11.1957875,12 13.4385861,13.939476 13.9091642,16.4991964 L27,16.5 C27.5522847,16.5 28,16.9477153 28,17.5 C28,18.0522847 27.5522847,18.5 27,18.5 L13.9093471,18.4998081 C13.4391676,21.0600211 11.196137,23 8.5,23 C5.46243388,23 3,20.5375661 3,17.5 C3,14.4624339 5.46243388,12 8.5,12 Z M8.5,14 C6.56700338,14 5,15.5670034 5,17.5 C5,19.4329966 6.56700338,21 8.5,21 C10.4329966,21 12,19.4329966 12,17.5 C12,15.5670034 10.4329966,14 8.5,14 Z",
    id: "Combined-Shape-Copy",
    fill: "#979598",
    transform: "translate(15.500000, 17.500000) rotate(-180.000000) translate(-15.500000, -17.500000) "
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.18584213f9309947348b97c661b48f5c.svg";
export { ForwardRef as ReactComponent };